export enum StatsPeriod {
  CurrentYear = 'CurrentYear',
  CurrentMonth = 'CurrentMonth',
  CurrentWeek = 'CurrentWeek',
  NextWeek = 'NextWeek',
  AllTime = 'AllTime',
  Perso = 'Perso',
}
